import { useQuery } from 'react-query'
import { getOpportunityOrderById } from '../../opportunities'

export default function useOpportunityOrder(query: any) {
  const { data, error, isLoading } = useQuery(
    ['opportunityOrder', query],
    () => getOpportunityOrderById(query),
    { enabled: !!query.id }
  )
  return { data, error, isLoading }
}
